import { ChessKingIcon } from './ChessKingIcon';

/**
 * author: Michael Richins
 * id 073FDF74-5305-45AB-8AC3-42A0FE6BBF9C
 * name chess-king
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chess-king.svg
 * tags
 * - Gaming / RPG 
 */
export const RoyaltyIcon = ChessKingIcon;
export default RoyaltyIcon